import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Ingreso } from 'src/app/model/index.model';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class IngresoService extends BaseService<Ingreso> {

    constructor(protected override http: HttpClient) {
        super(http, 'ingreso');
    }

}
